import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material';

interface CustomSnackBarData {
  message: string;
  icon?: string;
  type: 'success' | 'error' | 'copied' | 'info' | 'custom';
  action?: {
    text: string;
    callback: () => void;
  };
}

@Component({
  selector: 'custom-snackbar',
  templateUrl: './custom-snackbar.component.html',
  styleUrls: ['./custom-snackbar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CustomSnackBarComponent {
  public readonly message: string;
  public readonly icon: string;
  public readonly type: 'success' | 'error' | 'copied' | 'info' | 'custom';
  private readonly optionsFromIcons: { [key: string]: string };
  public readonly action: {
    text: string;
    callback: () => void;
  };

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: CustomSnackBarData) {
    this.message = data.message;
    this.type = data.type;
    this.action = data.action || null;
    this.optionsFromIcons = {
      success: 'check_circle',
      copied: 'content_copy',
      error: 'error',
      info: 'info',
      custom: data.icon
    };

    this.icon = this.optionsFromIcons[this.type];
  }
}
